import { Link } from "react-router";

import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { type DealResponseV2 } from "@vega-api/generated/types/dealResponseV2";
import { m } from "@vega-core/paraglide/messages";
import { formatShortSlashDate } from "@vega-core/utils/formatDate";
import { formatMoneyShortCompact } from "@vega-core/utils/formatMoney";
import { FundLogos } from "@vega-modules/components/AssetClassLogos/AssetClassImages";
import { CoInvestmentFullPaths } from "@vega-modules/paths";

import { CoInvestmentMetric } from "../CoInvestmentMetric/CoInvestmentMetric";

export type CoInvestmentItemProps = {
  item: DealResponseV2;
};

export const CoInvestmentItem = ({ item }: CoInvestmentItemProps) => {
  const { featureFlag } = useFeatureFlag();
  const dealLink = featureFlag[FeatureFlag.GP_COINVEST_NEW_UI_NAV_VD_25769]
    ? CoInvestmentFullPaths.CoInvestmentConfigure.replace(":id", item.id)
    : CoInvestmentFullPaths.CoInvestmentDetails.replace(":id", item.id);

  return (
    <Link
      className="grid grid-cols-1 xl:grid-cols-[1fr_.5fr] gap-4 justify-between py-4 md:px-6 md:py-5 hover:bg-background/component focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-default focus-visible:z-10 focus-visible:relative cursor-pointer first:border-t-1 first:border-border/primary last:border-b-1 last:border-border/primary"
      to={dealLink}
    >
      <>
        <div className="flex flex-col items-center col-span-1 sm:flex-row gap-4 px-2 md:px-0 min-w-0">
          <FundLogos bigSize />
          <div className="flex flex-col gap-y-2 min-w-0">
            <span
              className="body-semi-large-semibold md:body-large-semibold truncate"
              title={item.name}
            >
              {item.name}
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 divide-border/primary sm:items-center sm:gap-4">
          <CoInvestmentMetric
            title={m.common_targetRaise()}
            value={
              item.targetAmount ? (
                formatMoneyShortCompact(item.targetAmount)
              ) : (
                <span>&mdash;</span>
              )
            }
          />
          <CoInvestmentMetric
            title={m.common_closingDate()}
            value={
              item.closingDate ? (
                formatShortSlashDate(item.closingDate)
              ) : (
                <span>&mdash;</span>
              )
            }
          />
        </div>
      </>
    </Link>
  );
};
